import { dateFormatUtcToYMD } from "src/utils/dateManagement";
import { priceNameMap } from "src/utils/Mapper/priceNameMapper";
import { productInfo, ProductKey } from "src/config/config";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

interface ComputePromotionNoticeParams {
  serviceList: any[] | undefined;
  serviceEndTimeText: string;
  subscriptionEndDateText: string;
  isOciProduct: boolean;
  productKey: ProductKey;
}

export function useComputePromotionNotice({
  serviceList,
  serviceEndTimeText,
  subscriptionEndDateText,
  isOciProduct,
  productKey,
}: ComputePromotionNoticeParams): string {
  const { t } = useTranslation();
  if (!serviceList || serviceList.length === 0) return "";
  const first = serviceList[0];
  if (first.billType === "TRIAL") {
    return t("siteManagement.info1.Msg1", serviceEndTimeText);
  }
  if (first.billType === "PAY" && first.payStatus === "PAYED") {
    return t("siteManagement.info1.Msg2", {
      0:
        sessionStorage.getItem("product") === "WRAPSODY_ECO"
          ? first.priceName
          : priceNameMap[first.priceName],
      1: `${first.nextPayDate.substr(0, 4)}-${first.nextPayDate.substr(
        4,
        2
      )}-${first.nextPayDate.substr(6, 2)}`,
    });
  }
  if (first.billType === "PROMOTION" && first.payStatus === "PAYED") {
    return t("siteManagement.info1.Msg4", {
      0: "Premium",
      1: `${dayjs(subscriptionEndDateText).format("YYYY-MM-DD")} 09:00`,
    });
  }
  if (first.payStatus === "UNPAID") {
    return t("siteManagement.info1.Msg1", {
      0:
        isOciProduct && productKey === "WRAPSODY"
          ? "cloud.wrapsody.com"
          : first.domainName,
      1: `${dayjs(subscriptionEndDateText).format("YYYY-MM-DD")} 09:00`,
    });
  }
  if (first.payStatus === "SUSPENDED") {
    return t("siteManagement.info1.Msg4", {
      0:
        isOciProduct && productKey === "WRAPSODY"
          ? "cloud.wrapsody.com"
          : first.domainName,
      1: `${dayjs(subscriptionEndDateText).format("YYYY-MM-DD")} 09:00`,
    });
  }
  if (first.payStatus === "ENDING") {
    return t("siteManagement.info1.Msg5", {
      0:
        isOciProduct && productKey === "WRAPSODY"
          ? "cloud.wrapsody.com"
          : first.domainName,
      1: dateFormatUtcToYMD(first.serviceEndTime + 1000 * 60 * 60 * 24 * 30),
      2: productInfo[productKey as ProductKey]?.name,
    });
  }
  return "";
}
